export default __webpack_public_path__ + "static/media/arrowUpFrequently.d3c332d6.svg";